import { decimalSeparator } from './decimalSeparator';

export const numberWithSpaces = (x) => {
  return x || x === 0 ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')?.replace('.', decimalSeparator()) : '';
};

export const numberWithSpacesInter = (x, dig = null, maxDig) => {
  const dicim = decimalSeparator();
  
  if (x || x === 0) {
    if (dig === 0) return Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    let [integerPart, fractionalPart = ''] = x.toString().split('.');

    if (typeof maxDig === 'number' && maxDig >= 0) {
      const rounded = Number(x).toFixed(maxDig);
      [integerPart, fractionalPart = ''] = rounded.split('.');
      if (fractionalPart) {
        fractionalPart = fractionalPart.replace(/0+$/, '');
      }
    } else if (dig !== null) {
      fractionalPart = (fractionalPart + '0'.repeat(dig)).substring(0, dig);
    }

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if (typeof maxDig === 'number' && maxDig >= 0) {
      return fractionalPart
        ? `${integerPart}${dicim}${fractionalPart}`
        : integerPart;
    }

    return dig !== null
      ? `${integerPart}${dicim}${fractionalPart}`
      : (fractionalPart ? `${integerPart}${dicim}${fractionalPart}` : integerPart);
  }

  return '';
};

